module.exports = "<v-layout row wrap justify-center class=\"mb-3\">\n  <v-flex d-flex xs9>\n    <upload-button :buttons=\"coDocumentButtons\" v-model=\"vModel\" />\n  </v-flex>\n</v-layout>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/components/ticket-chat-modal-attach-documents/template.html
// module id = H4FU
// module chunks = 0